export const circleLoaderSizes = {
	xs: 18,
	sm: 22,
	md: 36,
	lg: 44,
	xl: 58,
};
